import { ze } from 'utils/zhEn';
import { ApiErrorCode } from 'utils/api-error-code';

/**
 * 信封 message 由后端按 languageSet 适配，且已拼上 TAPD 返回的 info/message 原文。
 * 这里不要再按 HTTP 状态码替换成泛化文案，否则会把字段校验失败细节丢掉。
 */
export function formatTapdErrorMessage(errorCode, message, fallback) {
  if (message) {
    return message;
  }
  if (errorCode === ApiErrorCode.TapdBugNotInWorkspace) {
    return ze('该缺陷不在当前绑定的 TAPD 项目中', 'This bug is not in the currently bound TAPD project');
  }
  if (errorCode === ApiErrorCode.TapdApiFailed) {
    return ze(
      'TAPD 接口调用失败，请稍后重试或检查缺陷管理平台配置',
      'Failed to call TAPD. Please retry later or check Bug Tracking Platform Settings.',
    );
  }
  return fallback || '';
}

/** 401/403/网络失败引导去配置页；422 等 TAPD 业务校验失败不引导。 */
export function shouldShowTapdConfigLink(errorCode, message) {
  if (errorCode !== ApiErrorCode.TapdApiFailed) {
    return false;
  }
  if (message && /HTTP\s+\d+/.test(message)) {
    return false;
  }
  return true;
}

export function getTapdErrorFromReject(err) {
  if (!err) {
    return {};
  }
  const json = err.json || {};
  return {
    errorCode: err.errorCode || json.errorCode,
    message: err.message || json.message,
  };
}
